import axios from "axios";
import { warn } from "./logger";
import { isLocal } from "./env";
import { USER_TOKEN_NAME, ADMIN_TOKEN_NAME } from "../redux/constants";

// Add authorization token to API calls
export const setAuthToken = (token) => {
  if (token) {
    warn(`[+] Adding Authorization token to API calls`);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    warn(`[-] Removing Authorization token from API calls`);
    delete axios.defaults.headers.common["Authorization"];
  }
};

export const setAxiosConfig = () => {
  axios.defaults.baseURL = isLocal() ? `http://localhost:8000/api/v1` : `/api/v1`;
  // axios.defaults.withCredentials = true;

  axios.interceptors.request.use((config) => {
    let token = localStorage.getItem(USER_TOKEN_NAME);
    const admin_token = localStorage.getItem(ADMIN_TOKEN_NAME);

    if (/^admin/.test(config.url) && admin_token) {
      token = admin_token;
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  // Set default error handling
  // axios.interceptors.response.use(
  //   (response) => {
  //     // Successful response - pass-through
  //     return response;
  //   },
  //   (error) => {
  //     if (
  //       error.response &&
  //       error.response.status === 401 &&
  //       redirectOnAuthUrl(error.response.config.url)
  //     ) {
  //       warn(`[i] Unauthorized to view ${error.response.config.url}`);
  //       delete axios.defaults.headers.common["Authorization"];
  //       localStorage.removeItem(USER_TOKEN_NAME);
  //       localStorage.removeItem(ADMIN_TOKEN_NAME);
  //
  //       window.location.replace("/auth/sign-in?reason=expired");
  //     }
  //
  //     return Promise.reject(error);
  //   }
  // );
};

/**
 * Don't redirect on the following urls
 * @param {string}  test_url
 * @return {boolean}
 */
// const redirectOnAuthUrl = (test_url) => {
//   const exclude_urls = ["/admin"];
//
//   return !!exclude_urls.find((url) => !new RegExp(test_url, "i").test(url));
// };
